import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b1f67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_12 = { class: "ant-input-group-addon" }
const _hoisted_13 = {
  class: "ss-card",
  style: {"padding":"0px"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_22 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: _ctx.props.tituloTela,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: "100%",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-financeiro':'full-modal ss-modal-financeiro',
    destroyOnClose: true
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (((_ctx.props.obrigarSelecaoValorEspecifico === 0 && _ctx.state.quantidadeMovimentosSelecionados > 0) || (_ctx.props.obrigarSelecaoValorEspecifico > 0 && _ctx.props.obrigarSelecaoValorEspecifico === _ctx.state.totalMovimentosSelecionados)))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
            }, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          (_ctx.state.conciliarMovimentoOfx)
            ? (_openBlock(), _createBlock(_component_card, {
                key: 0,
                titulo: "MOVIMENTO OFX A SER CONCILIADO"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        label: "Data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.props.movimentoOfx.dataMovimento)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        label: "Movimento"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.props.movimentoOfx.descricao), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        label: "Valor R$"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.props.movimentoOfx.valor)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        label: "Tipo"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.props.movimentoOfx.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                                _createTextVNode("Pagamento ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                                _createTextVNode("Recebimento ")
                              ], 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        label: " "
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscarMovimentos())),
                            checked: _ctx.state.apresentarTodosMovimentos,
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.apresentarTodosMovimentos) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('Apresentar ' + (_ctx.props.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Recebimento ? 'Pagamentos':'Recebimentos')) + " ", 1),
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: 'Você esta conciliando um ' + (_ctx.props.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Recebimento ? 'Recebimento':'Pagamento') + ' por padrão, você iria visualizar somente movimentos na Conta deste mesmo tipo, porém em casos de baixa ou movimentações mais complexas pode ser necessário você conciliar movimentos opostos como de ' + (_ctx.props.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Recebimento ? 'pagamentos':'recebimentos') + 'também.'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone-informacao-campo",
                                    nome: "informacao-campo"
                                  })
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_icone, {
                    class: "ss-icone",
                    nome: "pesquisar"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarMovimentos())),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                  class: "ant-input ss-alinhar-texto-esquerda",
                  placeholder: "Busca rápida: Digite o número de identificação, data, valor ou alguma informação para localizar a movimentação na conta..."
                }, null, 544), [
                  [_vModelText, _ctx.state.buscaRapida]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.state.movimentosFinanceiros,
              rowKey: "codigo",
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.storeSistema.state.layoutMobile ? null : { x: (_ctx.gradeBase.windowWidth), y: _ctx.defineAlturaScroll(38) },
              "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
              size: "small"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.key === 'TipoMovimento')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                            _createTextVNode("Pagamento ")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                            _createTextVNode("Recebimento ")
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                    : (column.key === 'MovimentoFinanceiro')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("span", null, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' +
                    record.descricaoTipoDocumentoFinanceiro), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_21,
                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor, 2)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  resultadoPesquisa: !_ctx.telaBase.carregando,
                  mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum título foi encontrado com estes filtros!'
                }, null, 8, ["resultadoPesquisa", "mensagem"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
          ]),
          (!_ctx.props.apenasUmMovimento)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_card, {
                    class: "ss-card-alinhado",
                    titulo: "MOVIMENTOS ENCONTRADOS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_totalizador, {
                            titulo: "QUANTIDADES",
                            valor: _ctx.state.quantidadeMovimentos,
                            casasDecimais: 0
                          }, null, 8, ["valor"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_totalizador, {
                            titulo: "TOTAL MOVIMENTOS",
                            monetario: true,
                            valor: _ctx.state.totalMovimentos
                          }, null, 8, ["valor"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_card, {
                    class: "ss-card-alinhado",
                    titulo: "MOVIMENTOS SELECIONADOS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_totalizador, {
                            titulo: "QUANTIDADES",
                            valor: _ctx.state.quantidadeMovimentosSelecionados,
                            casasDecimais: 0
                          }, null, 8, ["valor"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_totalizador, {
                            titulo: "TOTAL MOVIMENTOS",
                            monetario: true,
                            valor: _ctx.state.totalMovimentosSelecionados
                          }, null, 8, ["valor"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "visible", "wrap-class-name"]))
}